export default __webpack_public_path__ + "static/media/email.900f685e.svg";